<template>
  <div class="head">
    <!-- 头部编写 -->
    <div class="center">
      <div class="img"><img src="../../static/index/logo.png" alt="" /></div>
      <div class="language">
        <!-- <div class="languageBox" v-if="!isActive" @click="LanguageSwitch()">
          <span>CN</span>
        </div>

        <div class="languageBox" v-if="isActive" @click="LanguageSwitch()">
          <span>EN</span>
        </div> -->
      </div>
    </div>

    <!-- 导航条编写 -->
    <div class="nav">
      <div class="head-nav">
        <div class="head-nav-con clearFloat">
          <ul>
            <li>
              <router-link
                to="index"
                class="navv"
                :class="[active == 'index' ? 'active' : 'NoActive']"
                >{{ $t("navbar.home") }}</router-link
              >
            </li>


            <li class="drop-down">
              <router-link
                to=""
                class="navv"
                :class="[active == 'forum' ||active == 'guide' ||active == 'guestSpeaker'||active == 'guestDetail'? 'active': 'NoActive']"
                >{{ $t("navbar.introduction") }}
              </router-link>

              <ul class="drop-down-content">
                <li class="borderTop">
                  <router-link class="link" to="forum">论坛介绍</router-link>
                </li>
                <li>
                  <router-link class="link" to="guide">参会指南</router-link>
                </li>
                <li>
                  <router-link class="link" to="guestSpeaker"
                    >演讲嘉宾</router-link
                  >
                </li>
              </ul>
            </li>

            <li class="drop-down">
              <router-link
                to=""
                class="navv"
                :class="[active == 'mainForum' ? 'active' : 'NoActive']"
                >{{ $t("navbar.schedule") }}</router-link
              >

              <ul class="drop-down-content">
                <li class="borderTop">
                  <router-link
                    class="link"
                    to="mainForum"
                    :to="{ path: '/mainForum', query: { id: 2 } }"
                    >主论坛</router-link
                  >
                </li>
                <li>
                  <router-link
                    class="link"
                    :to="{ path: '/mainForum', query: { id: 3 } }"
                    >分论坛一</router-link
                  >
                </li>
                <!-- <li>
                  <router-link
                    class="link"
                    :to="{ path: '/mainForum', query: { id: 4 } }"
                    >分论坛二</router-link
                  >
                </li> -->
              </ul>
            </li>

            <li class="drop-down">
              <router-link
                to=""
                class="navv"
                :class="[
                  active == 'sinSpeak' || active == 'toSpeak'
                    ? 'active'
                    : 'NoActive',
                ]"
                >{{ $t("navbar.signAttend") }}</router-link
              >

              <ul class="drop-down-content">
                <li class="borderTop">
                  <router-link to="toSpeak" class="link">报名发言</router-link>
                </li>
                <li>
                  <router-link to="sinSpeak" class="link">报名听会</router-link>
                </li>
              </ul>
            </li>

            <li>
              <router-link
                to="sponsor"
                class="navv"
                :class="[active == 'sponsor' ? 'active' : 'NoActive']"
                >{{ $t("navbar.sponsorship") }}</router-link
              >
            </li>

            <li class="drop-down">
              <router-link
                to=""
                class="navv"
                :class="[
                  active == 'news' || active == 'workMedia'
                    ? 'active'
                    : 'NoActive',
                ]"
                >{{ $t("navbar.MediaCooperation") }}</router-link
              >

              <ul class="drop-down-content">
                <!-- <li class="borderTop ">
                  <router-link to="news" class="link">论坛新闻</router-link>
                </li> -->

                <li class="borderTop ">
                  <router-link to="workMedia" class="link " >合作媒体</router-link>
                </li>
              </ul>
            </li>

            <li>
              <router-link
                to="lastForum"
                class="navv"
                :class="[active == 'lastForum' ? 'active' : 'NoActive']"
                >{{ $t("navbar.lastYearBBS") }}</router-link
              >
            </li>

            <li>
              <router-link
                to="download"
                class="navv"
                :class="[active == 'download' ? 'active' : 'NoActive']"
                >{{ $t("navbar.downloadCenter") }}</router-link
              >
            </li>

            <li>
              <router-link
                to="contact"
                class="navv"
                :class="[active == 'contact' ? 'active' : 'NoActive']"
                >{{ $t("navbar.ContactUs") }}</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "I18nChange",
  data() {
    return {
      isActive: true, //中英混合切换
      active: "Index",
    };
  },
  methods: {
    LanguageSwitch() {
      // let lang = null;
      this.isActive = !this.isActive;
      // this.isActive ? (lang = "zh") : (lang = "en");
      // this.$i18n.locale = lang;
      // localStorage.removeItem("lang");
      // localStorage.setItem("lang", lang);
    },
    getPath() {
      let pathStr = this.$route.path;
      this.active = pathStr.substring(1, pathStr.length);
    },
  },
  created() {
    localStorage.setItem("lang", "zh"); //初始加载中文
  },
  watch: {
    $route: "getPath",
  },
};
</script>

<style lang="scss" scoped>
/* 编写头部 */
.head {
  width: 100%;
  background-image: url("../../static/index/topBack@2x.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  min-width: 1270px;
  .center {
    width: 1270px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .img {
      display: block;
      height: 120px;
      display: flex;
      align-items: center;
    }
    .language {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 13px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
      .languageBox {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
          width: 28px;
          height: 28px;
          margin-right: 6px;
        }
        span {
          width: 15px;
          text-align: center;
        }
      }
    }
  }
}
</style>
<style scoped>
.active {
  color: #fdd000 !important;
}

.NoActive {
  color: #fafafa !important;
}

li {
  list-style: none;
}
.head-nav {
  width: 100%;
  height: 50px;
  background: #006fb8;
}
.head-nav-con {
  width: 1270px;
  height: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.head-nav-con ul {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  z-index: 10000;
}
.head-nav-con ul li {
  display: block;
  font-size: 20px;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  width: 105px;
  line-height: 50px;
}
.borderTop {
  border-top: 3px solid gold;
}
.head-nav-con ul a {
  display: block;
  text-decoration: none;
  text-align: center;
  box-sizing: border-box;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
/* 激活的导航栏 */
.head-nav-con ul .drop-down-content a:hover {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #006fb8;
}

/* 下拉框下的弹框 */
.head-nav-con .drop-down-content li:hover > a {
  width: 105px;
  height: 50px;
  background: #ededed;
  line-height: 50px;
}

.head-nav-con .drop-down {
  position: relative;
}
.head-nav-con .drop-down-content {
  padding: 0;
  display: none;
  position: absolute;
  z-index: 1;
  background: #ffffff;
  left: 0px;
}

.head-nav-con .drop-down:hover .drop-down-content {
  display: block;
}
</style>
